// src/pages/admin/Productos.js
import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const fmtCOP = v => new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',minimumFractionDigits:0}).format(v||0);
const EMPTY = { nombre:'', descripcion:'', descripcion_corta:'', precio:'', costo:'', categoria_id:'', sku:'', stock:'', stock_minimo:10, ingredientes:'', modo_uso:'', beneficios:'', peso_gramos:'', activo:1, destacado:0, descuento_porcentaje:0, descuento_activo:0, titulos_secciones:'{}', medias_seccion:'[]' };

const TITULOS_DEFAULT = {
  seccion_viral: '¿Por qué todos están hablando de este producto?',
  seccion_modo_uso: '¿Cómo usarlo?',
  seccion_ingredientes: 'Ingredientes que cuidan tu piel',
  seccion_resenas: 'Lo que dicen nuestras clientas',
  seccion_comparativa: '¿Por qué elegir Wawita?',
  seccion_galeria: 'Fotos del producto',
};

const ICONOS_DISPONIBLES = [
  '✅','❌','⭐','🌿','🧴','👶','👕','🇨🇴','♻️','💚','🌱','🍃','🌸','🌺','🌻','🌹',
  '💧','☀️','🌙','❄️','🔥','💎','🏆','👑','💪','🩺','🧪','🔬','🌡️','💊','🩹',
  '🐾','🐶','🐱','🐠','🐝','🦋','🌈','⚡','🎯','✨','💫','🎁','🛡️','🔒','🚚',
  '💰','📦','🎀','💝','💖','💗','💓','❤️','🧡','💛','💜','🖤','🤍','🤎',
  '😊','😍','🥰','😎','🙌','👍','👏','🤝','💅','💆','🧘','🏃','🚴','⛹️',
  '🌾','🥥','🫐','🍋','🥑','🌶️','🫚','🧈','🍯','☕','🫖','🌿','🪴','🌵',
];

export default function Productos() {
  const [productos, setProductos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [editId, setEditId] = useState(null);
  const [buscar, setBuscar] = useState('');
  const [loading, setLoading] = useState(false);
  const [subiendoMedia, setSubiendoMedia] = useState(false);

  // Variaciones
  const [variaciones, setVariaciones] = useState([]);
  const TIPOS_VARIACION = ['Talla', 'Color', 'Gramaje', 'Presentacion', 'Aroma', 'Volumen', 'Otro'];

  const cargarVariaciones = async (productoId) => {
    if (!productoId) return;
    try {
      const r = await api.get('/variaciones/' + productoId);
      setVariaciones(r.data.variaciones || []);
    } catch { setVariaciones([]); }
  };

  const agregarVariacion = () => {
    setVariaciones(v => [...v, { id: 'new-' + Date.now(), tipo:'Talla', nombre:'', valor:'', precio_adicional:0, stock:0, sku:'', activo:1 }]);
  };

  const actualizarVariacion = (idx, campo, valor) => {
    setVariaciones(v => v.map((item, i) => i === idx ? {...item, [campo]: valor} : item));
  };

  const eliminarVariacion = (idx) => {
    setVariaciones(v => v.filter((_, i) => i !== idx));
  };

  // Titulos y medias de secciones
  const [titulosSecciones, setTitulosSecciones] = useState({});
  const [mediasSecciones, setMediasSecciones] = useState([]);         // URLs existentes
  const [mediasSeccionNuevas, setMediasSeccionNuevas] = useState([]); // archivos nuevos
  const [mediasSeccionPrev, setMediasSeccionPrev] = useState([]);     // previews

  // Estado de medias
  const [imagenPrincipalUrl, setImagenPrincipalUrl] = useState('');   // URL existente
  const [imagenPrincipalFile, setImagenPrincipalFile] = useState(null); // archivo nuevo
  const [imagenesExtras, setImagenesExtras] = useState([]);           // URLs existentes
  const [imagenesNuevas, setImagenesNuevas] = useState([]);           // archivos nuevos
  const [imagenesNuevasPrev, setImagenesNuevasPrev] = useState([]);   // previews nuevas
  const [videosExistentes, setVideosExistentes] = useState([]);
  const [videoNuevo, setVideoNuevo] = useState(null);

  const load = () => api.get('/productos?activo=0&todos=1').then(r => setProductos(r.data)).catch(()=>{});

  useEffect(() => {
    load();
    api.get('/productos/categorias/lista').then(r => setCategorias(r.data)).catch(()=>{});
  }, []);

  const abrir = (p = null) => {
    setEditId(p?.id || null);
    setForm(p ? { ...p } : EMPTY);
    // Cargar medias existentes
    setImagenPrincipalUrl(p?.imagen_principal || '');
    if (p?.id) cargarVariaciones(p.id);
    else setVariaciones([]);
    setImagenPrincipalFile(null);
    try { setImagenesExtras(JSON.parse(p?.imagenes || '[]')); } catch { setImagenesExtras([]); }
    try { setVideosExistentes(JSON.parse(p?.videos || '[]')); } catch { setVideosExistentes([]); }
    try { setTitulosSecciones(JSON.parse(p?.titulos_secciones || '{}')); } catch { setTitulosSecciones({}); }
    try { setMediasSecciones(JSON.parse(p?.medias_seccion || '[]')); } catch { setMediasSecciones([]); }
    setImagenesNuevas([]);
    setImagenesNuevasPrev([]);
    setVideoNuevo(null);
    setMediasSeccionNuevas([]);
    setMediasSeccionPrev([]);
    setModal(true);
  };

  const handleImagenPrincipal = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImagenPrincipalFile(file);
    setImagenPrincipalUrl(URL.createObjectURL(file)); // preview local
  };

  const handleImagenesNuevas = (e) => {
    const espacioDisponible = 5 - imagenesExtras.length - imagenesNuevasPrev.length;
    if (espacioDisponible <= 0) { toast.error('Maximo 5 fotos en la galeria'); return; }
    const files = Array.from(e.target.files).slice(0, espacioDisponible);
    setImagenesNuevas(prev => [...prev, ...files]);
    setImagenesNuevasPrev(prev => [...prev, ...files.map(f => URL.createObjectURL(f))]);
  };

  const eliminarImagenPrincipal = () => {
    setImagenPrincipalUrl('');
    setImagenPrincipalFile(null);
  };

  const eliminarImagenExtra = (idx) => {
    setImagenesExtras(prev => prev.filter((_,i) => i !== idx));
  };

  const eliminarImagenNueva = (idx) => {
    setImagenesNuevas(prev => prev.filter((_,i) => i !== idx));
    setImagenesNuevasPrev(prev => prev.filter((_,i) => i !== idx));
  };

  const eliminarVideo = (idx) => {
    setVideosExistentes(prev => prev.filter((_,i) => i !== idx));
  };

  const guardar = async () => {
    if (!form.nombre || !form.precio) return toast.error('Nombre y precio requeridos');
    setLoading(true);
    try {
      let imagenUrl = imagenPrincipalUrl;
      let imagenesUrls = [...imagenesExtras];
      let videosUrls = [...videosExistentes];

      // Subir imagen principal nueva a Cloudinary
      if (imagenPrincipalFile) {
        setSubiendoMedia(true);
        toast('Subiendo foto principal...', { icon: '☁️' });
        const fd = new FormData();
        fd.append('imagen', imagenPrincipalFile);
        const r = await api.post('/uploads/imagen', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        imagenUrl = r.data.url;
      }

      // Subir imagenes extras nuevas a Cloudinary
      if (imagenesNuevas.length > 0) {
        setSubiendoMedia(true);
        toast('Subiendo fotos adicionales...', { icon: '☁️' });
        const fd = new FormData();
        imagenesNuevas.forEach(f => fd.append('imagenes', f));
        const r = await api.post('/uploads/imagenes-multiples', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        imagenesUrls = [...imagenesUrls, ...r.data.imagenes.map(i => i.url)];
      }

      // Subir video nuevo
      if (videoNuevo) {
        setSubiendoMedia(true);
        toast('Subiendo video...', { icon: '🎬' });
        const fd = new FormData();
        fd.append('video', videoNuevo);
        const r = await api.post('/uploads/video', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        videosUrls = [...videosUrls, r.data.url];
      }

      setSubiendoMedia(false);

      // Subir medias de sección nuevas
      let mediasSeccUrls = [...mediasSecciones];
      if (mediasSeccionNuevas.length > 0) {
        setSubiendoMedia(true);
        toast('Subiendo medias de sección...', { icon: '🖼️' });
        for (const item of mediasSeccionNuevas) {
          const file = item.file;
          const isVideo = file.type.startsWith('video/');
          const fd = new FormData();
          if (isVideo) { fd.append('video', file); const r = await api.post('/uploads/video', fd, { headers: { 'Content-Type': 'multipart/form-data' } }); mediasSeccUrls.push({ tipo: 'video', url: r.data.url, puntos: item.puntos||[] }); }
          else { fd.append('imagen', file); const r = await api.post('/uploads/imagen', fd, { headers: { 'Content-Type': 'multipart/form-data' } }); mediasSeccUrls.push({ tipo: 'imagen', url: r.data.url, puntos: item.puntos||[] }); }
        }
      }
      setSubiendoMedia(false);

      const payload = {
        ...form,
        imagen_principal: imagenUrl,
        imagenes: JSON.stringify(imagenesUrls),
        videos: JSON.stringify(videosUrls),
        titulos_secciones: JSON.stringify(titulosSecciones),
        medias_seccion: JSON.stringify(mediasSeccUrls),
      };

      let productoId = editId;
      if (editId) {
        await api.put('/productos/' + editId, payload);
        toast.success('Producto actualizado');
      } else {
        const r = await api.post('/productos', payload);
        productoId = r.data.id;
        toast.success('Producto creado');
      }
      // Guardar variaciones
      if (variaciones.length > 0 && productoId) {
        await api.post('/variaciones/bulk/' + productoId, { variaciones });
      }
      setModal(false);
      load();
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.error || 'Error al guardar');
    } finally { setLoading(false); setSubiendoMedia(false); }
  };

  const desactivar = async (id) => {
    if (!window.confirm('Desactivar este producto?')) return;
    await api.delete(`/productos/${id}`);
    toast.success('Producto desactivado');
    load();
  };

  const filtrados = productos.filter(p => p.nombre.toLowerCase().includes(buscar.toLowerCase()));

  // Estilos reutilizables
  const btnEliminar = { position:'absolute', top:4, right:4, width:20, height:20, borderRadius:'50%', background:'rgba(200,0,0,0.85)', color:'#fff', border:'2px solid #fff', cursor:'pointer', fontSize:11, display:'flex', alignItems:'center', justifyContent:'center', fontWeight:900, lineHeight:1, zIndex:10, padding:0 };

  return (
    <div>
      <div style={{ background:'#fff', borderBottom:'1px solid var(--border)', padding:'14px 28px', display:'flex', alignItems:'center', justifyContent:'space-between', position:'sticky', top:0, zIndex:10 }}>
        <h1 style={{ fontSize:18, fontWeight:900, color:'var(--forest)' }}>Productos</h1>
        <div style={{ display:'flex', gap:10 }}>
          <input className="form-input" style={{ width:220 }} placeholder="Buscar producto..." value={buscar} onChange={e=>setBuscar(e.target.value)} />
          <button className="btn btn-primary" onClick={() => abrir()}>+ Nuevo producto</button>
        </div>
      </div>

      <div style={{ padding:'24px 28px' }}>
        <div className="card">
          <table className="table">
            <thead><tr><th>Foto</th><th>Producto</th><th>SKU</th><th>Precio</th><th>Descuento</th><th>Stock</th><th>Estado</th><th>Acciones</th></tr></thead>
            <tbody>
              {filtrados.map(p => (
                <tr key={p.id}>
                  <td>
                    <div style={{ width:52, height:52, borderRadius:8, overflow:'hidden', background:'var(--green-light)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:26 }}>
                      {p.imagen_principal
                        ? <img src={p.imagen_principal} alt={p.nombre} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                        : '🌿'}
                    </div>
                  </td>
                  <td><div style={{ fontWeight:700 }}>{p.nombre}</div><div style={{ fontSize:11, color:'var(--text-muted)' }}>{p.descripcion_corta?.slice(0,45)}</div></td>
                  <td style={{ fontSize:12, color:'var(--text-muted)' }}>{p.sku}</td>
                  <td style={{ fontWeight:700, color:'var(--green)' }}>{fmtCOP(p.precio)}</td>
                  <td>
                    {p.descuento_activo && p.descuento_porcentaje > 0
                      ? <span style={{ background:'var(--red)', color:'#fff', borderRadius:6, padding:'3px 8px', fontSize:12, fontWeight:800 }}>-{p.descuento_porcentaje}%</span>
                      : <span style={{ color:'var(--text-muted)', fontSize:12 }}>Sin descuento</span>}
                  </td>
                  <td style={{ fontWeight:700, color: p.stock <= p.stock_minimo ? 'var(--red)' : 'var(--forest)' }}>{p.stock}</td>
                  <td>
                    <span className={`badge ${p.activo ? 'badge-green' : 'badge-gray'}`}>{p.activo ? 'Activo' : 'Inactivo'}</span>
                    {p.destacado ? <span className="badge badge-yellow" style={{ marginLeft:4 }}>Top</span> : null}
                  </td>
                  <td>
                    <div style={{ display:'flex', gap:6 }}>
                      <button className="btn btn-outline btn-sm" onClick={() => abrir(p)}>Editar</button>
                      {p.activo ? <button className="btn btn-sm" style={{ background:'#fcebeb', color:'var(--red)', border:'none' }} onClick={() => desactivar(p.id)}>Quitar</button> : null}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ════ MODAL ════ */}
      {modal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.55)', zIndex:100, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
          <div style={{ background:'#fff', borderRadius:18, width:'100%', maxWidth:700, maxHeight:'92vh', overflowY:'auto' }}>
            <div style={{ padding:'18px 24px', borderBottom:'1px solid var(--border)', display:'flex', justifyContent:'space-between', alignItems:'center', position:'sticky', top:0, background:'#fff', zIndex:1 }}>
              <h2 style={{ fontSize:17, fontWeight:800, color:'var(--forest)' }}>{editId ? 'Editar producto' : 'Nuevo producto'}</h2>
              <button onClick={() => setModal(false)} style={{ background:'none', border:'none', fontSize:22, cursor:'pointer', color:'var(--text-muted)' }}>x</button>
            </div>
            <div style={{ padding:24 }}>

              {/* ── FOTO PRINCIPAL ── */}
              <div style={{ marginBottom:20 }}>
                <label className="form-label" style={{ display:'block', marginBottom:10 }}>Foto principal</label>
                <div style={{ display:'flex', gap:14, alignItems:'flex-start' }}>
                  {/* Preview */}
                  <div style={{ position:'relative', width:110, height:110, borderRadius:12, overflow:'visible', flexShrink:0 }}>
                    <div style={{ width:110, height:110, borderRadius:12, overflow:'hidden', background:'var(--green-light)', border:'2px dashed var(--green)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:40 }}>
                      {imagenPrincipalUrl
                        ? <img src={imagenPrincipalUrl} alt="principal" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                        : '🌿'}
                    </div>
                    {imagenPrincipalUrl && (
                      <button style={btnEliminar} onClick={eliminarImagenPrincipal} title="Eliminar foto principal">x</button>
                    )}
                  </div>
                  {/* Acciones */}
                  <div>
                    <label style={{ display:'inline-block', padding:'9px 16px', background:'var(--green-light)', color:'var(--green-dark)', borderRadius:8, cursor:'pointer', fontWeight:700, fontSize:13, border:'1.5px solid var(--green)' }}>
                      {imagenPrincipalUrl ? 'Cambiar foto' : 'Subir foto a Cloudinary'}
                      <input type="file" accept="image/*" style={{ display:'none' }} onChange={handleImagenPrincipal} />
                    </label>
                    <p style={{ fontSize:11, color:'var(--text-muted)', marginTop:6 }}>JPG, PNG o WEBP. Max 10MB.</p>
                    {imagenPrincipalFile && <p style={{ fontSize:12, color:'var(--green)', marginTop:4, fontWeight:600 }}>{imagenPrincipalFile.name}</p>}
                    <div style={{ marginTop:10 }}>
                      <p style={{ fontSize:11, color:'var(--text-muted)', marginBottom:4 }}>— o pega una URL de Cloudinary —</p>
                      <input
                        className="form-input"
                        style={{ fontSize:12 }}
                        placeholder="https://res.cloudinary.com/..."
                        value={imagenPrincipalFile ? '' : imagenPrincipalUrl}
                        onChange={e => { setImagenPrincipalUrl(e.target.value); setImagenPrincipalFile(null); }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* ── GALERIA ADICIONAL ── */}
              <div style={{ marginBottom:20 }}>
                <label className="form-label" style={{ display:'block', marginBottom:10 }}>
                  Galeria adicional
                  <span style={{ fontSize:11, fontWeight:400, color:'var(--text-muted)', marginLeft:8 }}>
                    ({imagenesExtras.length + imagenesNuevasPrev.length}/5 fotos)
                  </span>
                </label>

                {/* Fotos existentes */}
                <div style={{ display:'flex', flexWrap:'wrap', gap:10, marginBottom:12, overflow:'visible', paddingTop:10 }}>
                  {imagenesExtras.map((url, i) => (
                    <div key={i} style={{ position:'relative', overflow:'visible' }}>
                      <img src={url} alt="" style={{ width:80, height:80, objectFit:'cover', borderRadius:10, border:'1.5px solid var(--border)', display:'block' }} />
                      <button style={btnEliminar} onClick={() => eliminarImagenExtra(i)} title="Eliminar">✕</button>
                      <div style={{ position:'absolute', bottom:0, left:0, right:0, background:'rgba(0,0,0,0.45)', borderRadius:'0 0 8px 8px', fontSize:9, color:'#fff', textAlign:'center', padding:'2px 0', fontWeight:700 }}>GUARDADA</div>
                    </div>
                  ))}

                  {/* Fotos nuevas (pendientes de guardar) */}
                  {imagenesNuevasPrev.map((url, i) => (
                    <div key={'new-' + i} style={{ position:'relative', overflow:'visible' }}>
                      <img src={url} alt="" style={{ width:80, height:80, objectFit:'cover', borderRadius:10, border:'2px dashed var(--green)', display:'block' }} />
                      <button style={btnEliminar} onClick={() => eliminarImagenNueva(i)} title="Quitar">✕</button>
                      <div style={{ position:'absolute', bottom:0, left:0, right:0, background:'rgba(90,158,58,0.8)', borderRadius:'0 0 8px 8px', fontSize:9, color:'#fff', textAlign:'center', padding:'2px 0', fontWeight:700 }}>NUEVA</div>
                    </div>
                  ))}

                  {/* Boton agregar */}
                  {(imagenesExtras.length + imagenesNuevasPrev.length) < 5 && (
                    <label style={{ width:80, height:80, borderRadius:10, border:'2px dashed var(--border)', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', color:'var(--text-muted)', fontSize:28, flexShrink:0 }}>
                      +
                      <input type="file" accept="image/*" multiple style={{ display:'none' }} onChange={handleImagenesNuevas} />
                    </label>
                  )}
                </div>
                {/* URL manual para galería */}
                <div style={{ display:'flex', gap:8, marginTop:8 }}>
                  <input
                    className="form-input"
                    style={{ fontSize:12 }}
                    placeholder="Pegar URL de Cloudinary para galería..."
                    id="url-galeria-input"
                  />
                  <button
                    type="button"
                    className="btn btn-outline btn-sm"
                    style={{ whiteSpace:'nowrap' }}
                    onClick={() => {
                      const input = document.getElementById('url-galeria-input');
                      const url = input.value.trim();
                      if (!url) return;
                      if (imagenesExtras.length + imagenesNuevasPrev.length >= 5) return toast.error('Máximo 5 fotos');
                      setImagenesExtras(prev => [...prev, url]);
                      input.value = '';
                    }}
                  >+ Agregar URL</button>
                </div>
                <div style={{ display:'none' }}>
                </div>
                <p style={{ fontSize:11, color:'var(--text-muted)' }}>Las fotos con borde verde son nuevas y se subirán al guardar. Las etiquetadas "GUARDADA" ya están en Cloudinary.</p>
              </div>

              {/* ── VIDEOS ── */}
              <div style={{ marginBottom:20, background:'var(--cream)', borderRadius:12, padding:16 }}>
                <label className="form-label" style={{ display:'block', marginBottom:12 }}>Videos del producto</label>

                {/* Videos existentes */}
                {videosExistentes.length > 0 && (
                  <div style={{ display:'flex', flexWrap:'wrap', gap:10, marginBottom:12 }}>
                    {videosExistentes.map((url, i) => (
                      <div key={i} style={{ position:'relative' }}>
                        <video src={url} style={{ width:140, height:90, borderRadius:8, objectFit:'cover', background:'#000', display:'block' }} />
                        <button style={{ ...btnEliminar, top:-8, right:-8 }} onClick={() => eliminarVideo(i)}>x</button>
                        <div style={{ position:'absolute', bottom:0, left:0, right:0, background:'rgba(0,0,0,0.5)', borderRadius:'0 0 6px 6px', fontSize:9, color:'#fff', textAlign:'center', padding:'2px 0', fontWeight:700 }}>VIDEO GUARDADO</div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Agregar video nuevo */}
                {videoNuevo ? (
                  <div style={{ position:'relative', display:'inline-block' }}>
                    <video src={URL.createObjectURL(videoNuevo)} style={{ width:200, height:120, borderRadius:8, border:'2px dashed var(--green)', display:'block' }} controls />
                    <button style={btnEliminar} onClick={() => setVideoNuevo(null)}>x</button>
                    <div style={{ fontSize:12, color:'var(--green)', marginTop:4, fontWeight:600 }}>{videoNuevo.name}</div>
                  </div>
                ) : (
                  <label style={{ display:'inline-flex', alignItems:'center', gap:8, padding:'9px 16px', background:'#fff', borderRadius:8, cursor:'pointer', fontWeight:700, fontSize:13, border:'1.5px solid var(--border)' }}>
                    + Subir video (MP4, MOV - Max 500MB)
                    <input type="file" accept="video/mp4,video/mov,video/avi,video/webm" style={{ display:'none' }} onChange={e => { if(e.target.files[0]) setVideoNuevo(e.target.files[0]); }} />
                  </label>
                )}
                {/* URL manual video */}
                <div style={{ display:'flex', gap:8, marginTop:10 }}>
                  <input
                    className="form-input"
                    style={{ fontSize:12 }}
                    placeholder="O pega URL de video (Cloudinary, YouTube, etc)..."
                    id="url-video-input"
                  />
                  <button
                    type="button"
                    className="btn btn-outline btn-sm"
                    style={{ whiteSpace:'nowrap' }}
                    onClick={() => {
                      const input = document.getElementById('url-video-input');
                      const url = input.value.trim();
                      if (!url) return;
                      setVideosExistentes(prev => [...prev, url]);
                      input.value = '';
                    }}
                  >+ Agregar URL</button>
                </div>
              </div>

              {/* ── MEDIAS SECCIÓN VIRAL ── */}
              <div style={{ marginBottom:20, background:'#f0f0ff', borderRadius:12, padding:16 }}>
                <div style={{ fontWeight:800, fontSize:14, color:'#1e401f', marginBottom:4 }}>📸 Medias para sección "¿Por qué hablan de este producto?"</div>
                <div style={{ fontSize:12, color:'#7a8a7a', marginBottom:12 }}>Agrega imágenes, GIFs o videos que aparecen alternados con texto en esa sección. Si no hay medias, la sección no aparece.</div>
                <div style={{ display:'flex', flexWrap:'wrap', gap:10, marginBottom:12, paddingTop:8 }}>
                  {mediasSecciones.map((m, i) => (
                    <div key={i} style={{ background:'#fff', borderRadius:10, padding:10, border:'1.5px solid var(--border)', marginBottom:8, width:'100%' }}>
                      <div style={{ display:'flex', gap:10, alignItems:'flex-start' }}>
                        <div style={{ position:'relative', flexShrink:0 }}>
                          {m.tipo === 'video'
                            ? <video src={m.url} style={{ width:80, height:64, objectFit:'cover', borderRadius:6, border:'1.5px solid var(--border)', display:'block' }} />
                            : <img src={m.url} alt="" style={{ width:80, height:64, objectFit:'cover', borderRadius:6, border:'1.5px solid var(--border)', display:'block' }} />}
                          <div style={{ position:'absolute', bottom:0, left:0, right:0, background:'rgba(0,0,0,0.45)', borderRadius:'0 0 4px 4px', fontSize:8, color:'#fff', textAlign:'center', padding:'1px 0', fontWeight:700 }}>{m.tipo.toUpperCase()}</div>
                        </div>
                        <div style={{ flex:1, display:'flex', flexDirection:'column', gap:4 }}>
                          <div style={{ fontSize:11, fontWeight:700, color:'#1e401f', marginBottom:2 }}>Puntos de texto (solo se muestran los que tienen contenido)</div>
                          {(m.puntos || Array(8).fill({icono:'✅', texto:''})).map((punto, pi) => (
                            <div key={pi} style={{ display:'flex', gap:4, alignItems:'center' }}>
                              <select style={{ width:48, fontSize:16, border:'1px solid var(--border)', borderRadius:6, padding:'3px 2px', background:'#fff' }}
                                value={punto.icono||'✅'}
                                onChange={e => {
                                  const puntos = [...(m.puntos || Array(8).fill({icono:'✅', texto:''}))];
                                  puntos[pi] = {...puntos[pi], icono: e.target.value};
                                  setMediasSecciones(prev => prev.map((x,j) => j===i ? {...x, puntos} : x));
                                }}>
                                {ICONOS_DISPONIBLES.map(ic => <option key={ic} value={ic}>{ic}</option>)}
                              </select>
                              <input className="form-input" style={{ fontSize:12, flex:1 }}
                                placeholder={`Punto ${pi+1}...`}
                                value={punto.texto||''}
                                onChange={e => {
                                  const puntos = [...(m.puntos || Array(8).fill({icono:'✅', texto:''}))];
                                  puntos[pi] = {...puntos[pi], texto: e.target.value};
                                  setMediasSecciones(prev => prev.map((x,j) => j===i ? {...x, puntos} : x));
                                }} />
                            </div>
                          ))}
                        </div>
                        <button style={{ background:'#fcebeb', border:'none', color:'#a32d2d', borderRadius:6, padding:'4px 8px', cursor:'pointer', fontWeight:700, fontSize:12, flexShrink:0 }}
                          onClick={() => setMediasSecciones(prev => prev.filter((_,j) => j !== i))}>✕</button>
                      </div>
                    </div>
                  ))}
                  {mediasSeccionNuevas.map((item, i) => (
                    <div key={'new-'+i} style={{ background:'#f5f0ff', borderRadius:10, padding:10, border:'2px dashed #7c3aed', marginBottom:8, width:'100%' }}>
                      <div style={{ display:'flex', gap:10, alignItems:'flex-start' }}>
                        <div style={{ flexShrink:0 }}>
                          {item.preview
                            ? <img src={item.preview} alt="" style={{ width:80, height:64, objectFit:'cover', borderRadius:6, display:'block' }} />
                            : <div style={{ width:80, height:64, background:'#ddd', borderRadius:6, display:'flex', alignItems:'center', justifyContent:'center', fontSize:24 }}>🎬</div>}
                        </div>
                        <div style={{ flex:1, display:'flex', flexDirection:'column', gap:6 }}>
                          {(item.puntos || Array(8).fill({icono:'✅', texto:''})).map((punto, pi) => (
                            <div key={pi} style={{ display:'flex', gap:4, alignItems:'center' }}>
                              <select style={{ width:48, fontSize:16, border:'1px solid var(--border)', borderRadius:6, padding:'3px 2px', background:'#fff' }}
                                value={punto.icono||'✅'}
                                onChange={e => {
                                  const puntos = [...(item.puntos || Array(8).fill({icono:'✅', texto:''}))];
                                  puntos[pi] = {...puntos[pi], icono: e.target.value};
                                  setMediasSeccionNuevas(p => p.map((x,j) => j===i ? {...x, puntos} : x));
                                }}>
                                {ICONOS_DISPONIBLES.map(ic => <option key={ic} value={ic}>{ic}</option>)}
                              </select>
                              <input className="form-input" style={{ fontSize:12, flex:1 }}
                                placeholder={`Punto ${pi+1}...`}
                                value={punto.texto||''}
                                onChange={e => {
                                  const puntos = [...(item.puntos || Array(8).fill({icono:'✅', texto:''}))];
                                  puntos[pi] = {...puntos[pi], texto: e.target.value};
                                  setMediasSeccionNuevas(p => p.map((x,j) => j===i ? {...x, puntos} : x));
                                }} />
                            </div>
                          ))}
                          <div style={{ fontSize:10, color:'#7c3aed', fontWeight:700 }}>NUEVA — {item.file?.name}</div>
                        </div>
                        <button style={{ background:'#fcebeb', border:'none', color:'#a32d2d', borderRadius:6, padding:'4px 8px', cursor:'pointer', fontWeight:700, fontSize:12, flexShrink:0 }}
                          onClick={() => setMediasSeccionNuevas(p => p.filter((_,j) => j !== i))}>✕</button>
                      </div>
                    </div>
                  ))}
                  <label style={{ width:100, height:80, borderRadius:8, border:'2px dashed #7c3aed', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', color:'#7c3aed', fontSize:28, flexShrink:0, flexDirection:'column', gap:2 }}>
                    <span>+</span>
                    <span style={{ fontSize:9, fontWeight:700 }}>IMG/GIF/VIDEO</span>
                    <input type="file" accept="image/*,video/mp4,video/mov,video/webm" multiple style={{ display:'none' }}
                      onChange={e => {
                        const files = Array.from(e.target.files);
                        setMediasSeccionNuevas(p => [...p, ...files.map(f => ({ file: f, texto_beneficio:'', texto_problema:'', preview: f.type.startsWith('video/') ? null : URL.createObjectURL(f) }))]);
                      }} />
                  </label>
                </div>
                <div style={{ display:'flex', gap:8 }}>
                  <input className="form-input" style={{ fontSize:12 }} placeholder="O pega URL de imagen/GIF/video..." id="url-seccion-input" />
                  <button type="button" className="btn btn-outline btn-sm" style={{ whiteSpace:'nowrap' }}
                    onClick={() => {
                      const input = document.getElementById('url-seccion-input');
                      const url = input.value.trim();
                      if (!url) return;
                      const tipo = url.match(/\.(mp4|mov|webm|avi)$/i) ? 'video' : 'imagen';
                      setMediasSecciones(p => [...p, { tipo, url }]);
                      input.value = '';
                    }}>+ Agregar URL</button>
                </div>
              </div>

              {/* ── TÍTULOS DE SECCIONES ── */}
              <div style={{ marginBottom:20, background:'#fff8e7', borderRadius:12, padding:16 }}>
                <div style={{ fontWeight:800, fontSize:14, color:'#1e401f', marginBottom:4 }}>✏️ Títulos personalizables de secciones</div>
                <div style={{ fontSize:12, color:'#7a8a7a', marginBottom:12 }}>Deja en blanco para usar el título por defecto.</div>
                {Object.entries(TITULOS_DEFAULT).map(([key, defaultVal]) => (
                  <div className="form-group" key={key} style={{ marginBottom:10 }}>
                    <label className="form-label" style={{ fontSize:11 }}>{defaultVal}</label>
                    <input className="form-input" style={{ fontSize:12 }}
                      value={titulosSecciones[key] || ''}
                      placeholder={defaultVal}
                      onChange={e => setTitulosSecciones(t => ({ ...t, [key]: e.target.value }))} />
                  </div>
                ))}
              </div>

              {/* ── DATOS DEL PRODUCTO ── */}
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(200px, 1fr))', gap:12 }}>
                <div className="form-group" style={{ gridColumn:'1/-1' }}>
                  <label className="form-label">Nombre del producto *</label>
                  <input className="form-input" value={form.nombre} onChange={e=>setForm(f=>({...f,nombre:e.target.value}))} placeholder="Ej: Desodorante Natural" />
                </div>
                <div className="form-group">
                  <label className="form-label">Precio venta (COP) *</label>
                  <input className="form-input" type="number" value={form.precio} onChange={e=>setForm(f=>({...f,precio:e.target.value}))} placeholder="28000" />
                </div>
                <div className="form-group">
                  <label className="form-label">Costo produccion (COP)</label>
                  <input className="form-input" type="number" value={form.costo} onChange={e=>setForm(f=>({...f,costo:e.target.value}))} placeholder="12000" />
                </div>
                <div className="form-group">
                  <label className="form-label">SKU</label>
                  <input className="form-input" value={form.sku} onChange={e=>setForm(f=>({...f,sku:e.target.value}))} placeholder="WAW-DES-001" />
                </div>
                <div className="form-group">
                  <label className="form-label">Categoria</label>
                  <select className="form-input" value={form.categoria_id} onChange={e=>setForm(f=>({...f,categoria_id:e.target.value}))}>
                    <option value="">Sin categoria</option>
                    {categorias.map(c => <option key={c.id} value={c.id}>{c.icono} {c.nombre}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Stock actual</label>
                  <input className="form-input" type="number" value={form.stock} onChange={e=>setForm(f=>({...f,stock:e.target.value}))} placeholder="0" />
                </div>
                <div className="form-group">
                  <label className="form-label">Stock minimo</label>
                  <input className="form-input" type="number" value={form.stock_minimo} onChange={e=>setForm(f=>({...f,stock_minimo:e.target.value}))} placeholder="10" />
                </div>
                <div className="form-group">
                  <label className="form-label">Peso (gramos)</label>
                  <input className="form-input" type="number" value={form.peso_gramos} onChange={e=>setForm(f=>({...f,peso_gramos:e.target.value}))} placeholder="50" />
                </div>
                <div className="form-group" style={{ gridColumn:'1/-1' }}>
                  <label className="form-label">Descripcion corta</label>
                  <input className="form-input" value={form.descripcion_corta} onChange={e=>setForm(f=>({...f,descripcion_corta:e.target.value}))} />
                </div>
                <div className="form-group" style={{ gridColumn:'1/-1' }}>
                  <label className="form-label">Descripcion completa</label>
                  <textarea className="form-input" rows={3} value={form.descripcion} onChange={e=>setForm(f=>({...f,descripcion:e.target.value}))} style={{ resize:'vertical' }} />
                </div>

              <div style={{ gridColumn:'1/-1', background:'#f0f7ee', borderRadius:12, padding:16, marginTop:8 }}>
                <div style={{ fontWeight:800, fontSize:14, color:'#1e401f', marginBottom:16 }}>Secciones página de producto</div>
                <div className="form-group">
                  <label className="form-label">¿Te pasa esto? <span style={{fontSize:11,color:'#7a8a7a',fontWeight:400}}>(un problema por línea)</span></label>
                  <textarea className="form-input" rows={4} value={form.problema||''} onChange={e=>setForm(f=>({...f,problema:e.target.value}))} placeholder="Manchas en la ropa&#10;Irritación con otros desodorantes" style={{resize:'vertical'}} />
                </div>
                <div className="form-group" style={{marginTop:12}}>
                  <label className="form-label">Tu compra incluye <span style={{fontSize:11,color:'#7a8a7a',fontWeight:400}}>(uno por línea)</span></label>
                  <textarea className="form-input" rows={3} value={form.incluye||''} onChange={e=>setForm(f=>({...f,incluye:e.target.value}))} placeholder="Desodorante natural 50g&#10;Guía de uso" style={{resize:'vertical'}} />
                </div>
              </div>

                <div className="form-group" style={{ gridColumn:'1/-1' }}>
                  <label className="form-label">Ingredientes <span style={{fontSize:11,color:"#7a8a7a",fontWeight:400}}>(uno por línea)</span></label>
                  <textarea className="form-input" rows={2} value={form.ingredientes} onChange={e=>setForm(f=>({...f,ingredientes:e.target.value}))} style={{ resize:'vertical' }} />
                </div>
                <div className="form-group" style={{ gridColumn:'1/-1' }}>
                  <label className="form-label">Modo de uso <span style={{fontSize:11,color:"#7a8a7a",fontWeight:400}}>(un paso por línea)</span></label>
                  <textarea className="form-input" rows={2} value={form.modo_uso} onChange={e=>setForm(f=>({...f,modo_uso:e.target.value}))} style={{ resize:'vertical' }} />
                </div>
                <div className="form-group" style={{ gridColumn:'1/-1' }}>
                  <label className="form-label">Beneficios <span style={{fontSize:11,color:"#7a8a7a",fontWeight:400}}>(uno por línea)</span></label>
                  <textarea className="form-input" rows={2} value={form.beneficios} onChange={e=>setForm(f=>({...f,beneficios:e.target.value}))} style={{ resize:'vertical' }} />
                </div>
                {/* DESCUENTO */}
                <div style={{ gridColumn:'1/-1', background:'var(--cream)', borderRadius:12, padding:16 }}>
                  <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:12 }}>
                    <div>
                      <div style={{ fontWeight:800, fontSize:14, color:'var(--forest)' }}>Descuento por porcentaje</div>
                      <div style={{ fontSize:12, color:'var(--text-muted)', marginTop:2 }}>Aparece como badge rojo en la tienda</div>
                    </div>
                    <label style={{ display:'flex', alignItems:'center', gap:8, fontSize:14, fontWeight:600, cursor:'pointer' }}>
                      <input type="checkbox" checked={!!form.descuento_activo} onChange={e=>setForm(f=>({...f,descuento_activo:e.target.checked?1:0}))} />
                      Activar descuento
                    </label>
                  </div>
                  {!!form.descuento_activo && (
                    <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                      <div style={{ flex:1 }}>
                        <label className="form-label">Porcentaje de descuento</label>
                        <input className="form-input" type="number" min="1" max="99" value={form.descuento_porcentaje} onChange={e=>setForm(f=>({...f,descuento_porcentaje:e.target.value}))} placeholder="20" />
                      </div>
                      {form.precio && form.descuento_porcentaje > 0 && (
                        <div style={{ textAlign:'center', paddingTop:20 }}>
                          <div style={{ fontSize:12, color:'var(--text-muted)', textDecoration:'line-through' }}>{fmtCOP(parseFloat(form.precio))}</div>
                          <div style={{ fontSize:20, fontWeight:900, color:'var(--red)' }}>{fmtCOP(Math.round(parseFloat(form.precio) * (1 - parseFloat(form.descuento_porcentaje)/100)))}</div>
                          <div style={{ background:'var(--red)', color:'#fff', borderRadius:6, padding:'2px 8px', fontSize:11, fontWeight:800, display:'inline-block', marginTop:4 }}>-{form.descuento_porcentaje}% OFF</div>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div style={{ display:'flex', gap:20, gridColumn:'1/-1' }}>
                  <label style={{ display:'flex', alignItems:'center', gap:8, fontSize:14, fontWeight:600, cursor:'pointer' }}>
                    <input type="checkbox" checked={!!form.activo} onChange={e=>setForm(f=>({...f,activo:e.target.checked?1:0}))} />
                    Activo (visible en tienda)
                  </label>
                  <label style={{ display:'flex', alignItems:'center', gap:8, fontSize:14, fontWeight:600, cursor:'pointer' }}>
                    <input type="checkbox" checked={!!form.destacado} onChange={e=>setForm(f=>({...f,destacado:e.target.checked?1:0}))} />
                    Destacado
                  </label>
                </div>
              </div>

              {/* VARIACIONES */}
              <div style={{ gridColumn:'1/-1', background:'var(--cream)', borderRadius:12, padding:16, marginTop:8 }}>
                <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:12 }}>
                  <div>
                    <div style={{ fontWeight:800, fontSize:14, color:'var(--forest)' }}>Variaciones del producto</div>
                    <div style={{ fontSize:12, color:'var(--text-muted)', marginTop:2 }}>Tallas, colores, gramajes, presentaciones, etc.</div>
                  </div>
                  <button type="button" onClick={agregarVariacion} className="btn btn-outline btn-sm">+ Agregar variacion</button>
                </div>
                {variaciones.length === 0 ? (
                  <div style={{ textAlign:'center', padding:'16px 0', color:'var(--ink-faint)', fontSize:13 }}>
                    Sin variaciones — el producto tiene precio y stock fijo
                  </div>
                ) : (
                  <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
                    {variaciones.map((v, idx) => (
                      <div key={v.id} style={{ background:'#fff', borderRadius:'var(--r-md)', padding:'12px 14px', border:'1px solid rgba(28,58,30,0.1)' }}>
                        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(120px, 1fr))', gap:8, alignItems:'center' }}>
                          <div>
                            <div style={{ fontSize:10, fontWeight:700, color:'var(--ink-faint)', marginBottom:3 }}>TIPO</div>
                            <select className="form-input" style={{ padding:'6px 8px', fontSize:12 }} value={v.tipo} onChange={e=>actualizarVariacion(idx,'tipo',e.target.value)}>
                              {TIPOS_VARIACION.map(t => <option key={t} value={t}>{t}</option>)}
                            </select>
                          </div>
                          <div>
                            <div style={{ fontSize:10, fontWeight:700, color:'var(--ink-faint)', marginBottom:3 }}>VALOR</div>
                            <input className="form-input" style={{ padding:'6px 8px', fontSize:12 }} placeholder="Ej: XL, Rojo, 100g" value={v.valor} onChange={e=>actualizarVariacion(idx,'valor',e.target.value)} />
                          </div>
                          <div>
                            <div style={{ fontSize:10, fontWeight:700, color:'var(--ink-faint)', marginBottom:3 }}>PRECIO TOTAL</div>
                            <input className="form-input" style={{ padding:'6px 8px', fontSize:12 }} type="number" placeholder="Ej: 35000" value={v.precio_adicional} onChange={e=>actualizarVariacion(idx,'precio_adicional',Number(e.target.value))} />
                          </div>
                          <div>
                            <div style={{ fontSize:10, fontWeight:700, color:'var(--ink-faint)', marginBottom:3 }}>STOCK</div>
                            <input className="form-input" style={{ padding:'6px 8px', fontSize:12 }} type="number" placeholder="0" value={v.stock} onChange={e=>actualizarVariacion(idx,'stock',Number(e.target.value))} />
                          </div>
                          <div>
                            <div style={{ fontSize:10, fontWeight:700, color:'var(--ink-faint)', marginBottom:3 }}>SKU</div>
                            <input className="form-input" style={{ padding:'6px 8px', fontSize:12 }} placeholder="Opcional" value={v.sku||''} onChange={e=>actualizarVariacion(idx,'sku',e.target.value)} />
                          </div>
                          <button onClick={() => eliminarVariacion(idx)} style={{ background:'#fcebeb', border:'none', color:'#a32d2d', borderRadius:'var(--r-sm)', padding:'6px 10px', cursor:'pointer', fontWeight:700, fontSize:14, marginTop:16 }}>✕</button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div style={{ display:'flex', gap:10, marginTop:24 }}>
                <button className="btn btn-primary" style={{ flex:1, padding:13 }} onClick={guardar} disabled={loading || subiendoMedia}>
                  {subiendoMedia ? 'Subiendo archivos...' : loading ? 'Guardando...' : editId ? 'Guardar cambios' : 'Crear producto'}
                </button>
                <button className="btn btn-outline" style={{ padding:13 }} onClick={() => setModal(false)}>Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
